import React from 'react';
import { SummaryType } from '../../../../common/commonTypes';
import MacroBar from '../MacrosChart/MacroBar';
import { useTranslation } from 'react-i18next';

type MacrosGoalsChartType = {
    goals: SummaryType;
    dailySummary: SummaryType;
};

const findLargestMacroValue = (goals: SummaryType, dailySummary: SummaryType) => {
    const macros = ['protein', 'fats', 'carbsNoSugars', 'sugars'];
    const values = macros.flatMap((macro) => [
        // @ts-ignore
        goals[macro],
        // @ts-ignore
        dailySummary[macro],
    ]);
    return Math.max(...values);
};

const isUnderOverClass = (daily: number, goal: number) => {
    if (goal === 0) return '';

    if (daily < goal * 0.9) {
        return '';
    }

    if (daily >= goal * 0.9 && daily <= goal * 1.1) {
        return 'text-green-500';
    }

    if (daily > goal * 1.1) {
        return 'text-red-500';
    }

    return '';
};

const leftForToday = (goal: number, today: number): string | number => {
    return goal - today > 0 ? goal - today : '--';
};

const MacrosGoalsChart = (props: MacrosGoalsChartType) => {
    const { goals, dailySummary } = props;

    const { t, i18n } = useTranslation();

    const macrosMax = findLargestMacroValue(goals, dailySummary);
    const caloriesMax = Math.max(goals.calories, dailySummary.calories);

    return (
        <>
            <table className="text-md w-full mb-2">
                <tbody>
                    <tr>
                        <td className="w-20">{t('calories')}:</td>
                        <td
                            className={`w-10 ${isUnderOverClass(dailySummary.calories, goals.calories)}`}
                        >
                            {dailySummary.calories}
                        </td>
                        <td className="w-auto">
                            <MacroBar
                                type={'CALORIES'}
                                daily={dailySummary.calories}
                                weekly={goals.calories}
                                max={caloriesMax}
                            />
                        </td>
                        <td className="w-10 text-right text-gray-400 pr-1 text-sm">
                            {leftForToday(goals.calories, dailySummary.calories)}
                        </td>
                        <td className="w-10 text-right">{goals.calories}</td>
                    </tr>
                </tbody>
            </table>

            <table className="text-sm w-full">
                <tbody>
                    <tr>
                        <td className="w-20">{t('protein_gr')}:</td>
                        <td
                            className={`w-10 ${isUnderOverClass(dailySummary.protein, goals.protein)}`}
                        >
                            {dailySummary.protein}
                        </td>
                        <td className="w-auto">
                            <MacroBar
                                type={'PROTEIN'}
                                daily={dailySummary.protein}
                                weekly={goals.protein}
                                max={macrosMax}
                            />
                        </td>
                        <td className="w-10 text-right  text-gray-400 pr-1 text-sm">
                            {leftForToday(goals.protein, dailySummary.protein)}
                        </td>
                        <td className="w-10 text-right"> {goals.protein} </td>
                    </tr>
                    <tr>
                        <td className="w-20">{t('fat_gr')}:</td>
                        <td className={`w-10 ${isUnderOverClass(dailySummary.fats, goals.fats)}`}>
                            {dailySummary.fats}
                        </td>
                        <td className="w-auto">
                            <MacroBar
                                type={'FAT'}
                                daily={dailySummary.fats}
                                weekly={goals.fats}
                                max={macrosMax}
                            />
                        </td>
                        <td className="w-10 text-right text-gray-400 pr-1 text-sm">
                            {leftForToday(goals.fats, dailySummary.fats)}
                        </td>
                        <td className="w-10 text-right">{goals.fats}</td>
                    </tr>
                    <tr>
                        <td className="w-20">{t('carbs_gr')}:</td>
                        <td
                            className={`w-10 ${isUnderOverClass(dailySummary.carbsNoSugars, goals.carbsNoSugars)}`}
                        >
                            {dailySummary.carbsNoSugars}
                        </td>
                        <td className="w-auto">
                            <MacroBar
                                type={'CARBS'}
                                daily={dailySummary.carbsNoSugars}
                                weekly={goals.carbsNoSugars}
                                max={macrosMax}
                            />
                        </td>
                        <td className="w-10 text-right text-gray-400 pr-1 text-sm">
                            {leftForToday(goals.carbsNoSugars, dailySummary.carbsNoSugars)}
                        </td>
                        <td className="w-10 text-right">{goals.carbsNoSugars}</td>
                    </tr>
                    <tr>
                        <td className="w-20">{t('sugar_gr')}:</td>
                        <td
                            className={`w-10 ${isUnderOverClass(dailySummary.sugars, goals.sugars)}`}
                        >
                            {dailySummary.sugars}
                        </td>
                        <td className="w-auto">
                            <MacroBar
                                type={'SUGARS'}
                                daily={dailySummary.sugars}
                                weekly={goals.sugars}
                                max={macrosMax}
                            />
                        </td>
                        <td className="w-10 text-right text-gray-400 pr-1 text-sm">
                            {leftForToday(goals.sugars, dailySummary.sugars)}
                        </td>
                        <td className="w-10 text-right">{goals.sugars}</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

export default MacrosGoalsChart;
